import EventManager from './eventManager.vue';
import EventList from './views/eventList.vue';

export const eventManagerRoutes = [
  {
    path: 'eventManager',
    component: EventManager,
    children: [
      { path: '', component: EventList, name: 'eventList' }
    ]
  }
];
